import { tw, twx } from '@ctw/shared/utils/tailwind';

export const confidenceLevels = { low: 1, medium: 2, high: 3 } as const;
export type ConfidenceLevel = keyof typeof confidenceLevels;

export interface ConfidenceScaleProps {
  confidenceLevel: ConfidenceLevel | null | undefined;
  hideLabel?: boolean;
}

export const ConfidenceScale = ({ confidenceLevel, hideLabel }: ConfidenceScaleProps) => {
  return (
    <div className={tw`flex items-center gap-1`}>
      <div aria-hidden={true} className={tw`flex gap-[2px]`}>
        {Object.keys(confidenceLevels).map((indicatorLevel) => (
          <div
            key={indicatorLevel}
            className={twx('h-[12.38px] w-[3px] rounded-[10px]', {
              'bg-background-subtle':
                !confidenceLevel ||
                confidenceLevels[confidenceLevel] < confidenceLevels[indicatorLevel as never],
              'bg-background-icon':
                confidenceLevel &&
                confidenceLevels[confidenceLevel] >= confidenceLevels[indicatorLevel as never],
            })}
          >
            &#65279;
          </div>
        ))}
      </div>
      {!hideLabel && (
        <div className={tw`text-content-main text-sm uppercase`}>
          {confidenceLevel ?? 'Unknown'}
        </div>
      )}
    </div>
  );
};
